import { useMemo } from 'react';
import { type ChartSegment, type SelectedChartSegment } from '@/app/config/chart-segments';

interface UseSelectedChartSegmentProperties<T extends ChartSegment> {
  segments: T[];
  selectedIndex: number | null;
}

const useSelectedChartSegment = <T extends ChartSegment>({
  segments,
  selectedIndex,
}: UseSelectedChartSegmentProperties<T>): SelectedChartSegment | null => {
  return useMemo(() => {
    if (selectedIndex === null) return null;

    const segment = segments.at(selectedIndex);

    if (!segment) return null;

    return {
      ...segment,
      segmentIndex: selectedIndex,
    };
  }, [segments, selectedIndex]);
};

export default useSelectedChartSegment;
